import { Options } from "ky";
import { fetcher } from "../fetcher";
import { Pagination } from "../pagination";
import { StockOverview, StockDetail, AreaStock } from "../car/type";

export async function getIndex(areaName: string, carName: string, options?: Options): Promise<Pagination<StockOverview>> {
  return await fetcher.get(`car?areaName=${areaName}&carName=${carName}`, options).json();
}

export async function getAreaStocks(areaName: string, options?: Options): Promise<{ data: Array<AreaStock> }> {
  return await fetcher.get(`car/stock/${areaName}`, options).json();
}

export async function fetchStockOverview(chassisNumber: string, winterTireOption = 0): Promise<{ data: StockOverview }> {
  return await fetcher.get(`apply-informations/${chassisNumber}/overview/${winterTireOption}`).json();
}

export async function fetchStockDetail(chassisNumber: string): Promise<{ data: StockDetail }> {
  return await fetcher.get(`car/${chassisNumber}`).json();
}